import { render, staticRenderFns } from "./objectStageSet.vue?vue&type=template&id=356ec495"
import script from "./objectStageSet.vue?vue&type=script&lang=js"
export * from "./objectStageSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356ec495')) {
      api.createRecord('356ec495', component.options)
    } else {
      api.reload('356ec495', component.options)
    }
    module.hot.accept("./objectStageSet.vue?vue&type=template&id=356ec495", function () {
      api.rerender('356ec495', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectStageSet.vue"
export default component.exports